module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/circle--blue-dc58263a0ccffd7122b937c2779d7106.png";